// Карточка задачи лонча с другого экрана (Release Plan, History): доска её лонча собирается из стора,
// присутствие «редактирует» — как на Launch Board.
import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { data, useTable } from '@core/store';
import { LaunchTaskModal } from './LaunchTaskModal';
import { boardOf, launchIdOfTrack, launchTaskDraftOf, type LaunchTask, type LaunchTaskDraft } from './planner';

export function useLaunchTaskCard(): { open: (t: LaunchTask) => void; node: ReactNode } {
  const swimlanes = useTable('launch_swimlane');
  const tracks = useTable('launch_track');
  const tasks = useTable('launch_task');
  const [card, setCard] = useState<{ draft: LaunchTaskDraft; launchId: string } | null>(null);
  const open = useCallback((t: LaunchTask) => {
    const tbl = data.store.getState().tables;
    const launchId = launchIdOfTrack(t.track_id, tbl.launch_track, tbl.launch_swimlane);
    if (!launchId) return;
    setCard({ draft: launchTaskDraftOf(t, tbl.launch_link.values()), launchId });
    data.updatePresence({ editing: t.id });
  }, []);
  const close = useCallback(() => { setCard(null); data.updatePresence({ editing: null }); }, []);
  const board = useMemo(() => (card ? boardOf(card.launchId, swimlanes.values(), tracks.values(), tasks.values()) : null), [card, swimlanes, tracks, tasks]);
  const node = card && board ? <LaunchTaskModal draft={card.draft} swimlanes={board.lanes} tracks={board.tracks} launchTasks={board.tasks} onClose={close} /> : null;
  return { open, node };
}
